import { create } from 'zustand';

export const useApplicationStore = create((set, get) => ({
	zipCode: null,
	setZipCode: (zip) => set({ zipCode: zip }),
	program: null,
	setProgram: (program) => set({ program }),
	idempotencyKey: null,
	setIdempotencyKey: (idempotencyKey) => set({ idempotencyKey }),
	clearApplication: () =>
		set({
			zipCode: null,
			program: null,
			idempotencyKey: null,
		}),
	// The chosen program is the sole source for the request: its name is the
	// service description and its id is the external reference. The idempotency
	// key lets the server dedupe a resubmitted request.
	getApplication: () => {
		const { program, idempotencyKey } = get();
		return {
			taxonomy_detail: program?.name,
			external_id: program?.id,
			idempotency_key: idempotencyKey,
		};
	},
}));
